import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import {  useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";


//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const EditEducation: FC = () => {
      const intl = useIntl()
      let history = useHistory();
      const [educationInfo, setEducationInfo] = useState([]);
      const red="red";
      const location99 = useLocation();
     const queryParams99 = new URLSearchParams(location99.search);
      const educationId = queryParams99.get('educationId');
      const educationTitle = queryParams99.get('name');
      //const educationTitle = queryParams99.get('name');
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

      
      function getEducationById(){
          services.getEducationsById(educationId).then((res) => 
          {
            console.log(res);
            const myres = JSON.stringify(res);
            
            if(res){     
              $('#education_title').val(res.data.name);          
            setEducationInfo(res.data); 
              //lert(res.data.eventTitle)
              //$("#eventTitle").val(res.data.eventTitle);  
            }  
          });
       }
      const submitValue = () => {
        var validateEditorTxt = 1;
        if($('#education_title').val() == ""){
          $("#educationNameValidMsg").show();  
          $(window).scrollTop($('#educationNameValidMsg').position().top);
          validateEditorTxt = 0;     
        }else{
          $("#educationNameValidMsg").hide();  
        }

        if(validateEditorTxt == 0){
          return false;
         }
          
        const requestObject={
            "educationId":educationId,
            "name":$("#education_title").val(),
        }
        console.log(requestObject);
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };

        services.adminEditEducation(requestOptions).then((res) => 
        {
          if (res.code == '200') {
            $("#editeducationsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#editeducationsuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              history.push('/educationlist');
            }, 1000);
          }
          else{
            $("#editeducationfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#editeducationfailMessage").slideUp(500);
            });
            setTimeout(() => {
             
            }, 1000);
          }
        });
        
      }
      useEffect(() => 
      {      
        getEducationById();
        $('#educationNameValidMsg').hide();
        $('#editeducationsuccessMessage').hide();
        $('#editeducationfailMessage').hide();
       //$('#education_title').val(educationTitle);
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Edit Education'})}</PageTitle>
         
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
                 

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Education Title</label>
                 
                 </div>
                  <input type="text" id="education_title" name="education_title" className="form-control"  />
                  <div id="educationNameValidMsg" style={{color:red}} className="error">Education Title is required.</div>
              </div>
                 </div>
                
                
                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <button type="submit" className="btn btn-primary mt-10" style={{maxWidth: "200px"}}> Update Education </button>
                 </div>
                 </div>
                 <div id="editeducationsuccessMessage" className="alert alert-success" role="alert">Education Updated Successfully</div>
                 <div id="editeducationfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {EditEducation}